export default __webpack_public_path__ + "static/media/dodecahedron.fee4c230.usdz";